import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "adNetwork",
  initialState: {
    data : [],
  },
  reducers: {
    setAdNetwork: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setAdNetwork } = appSlice.actions;
export default appSlice.reducer;